import { MobileOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';

// A Mobile app's icon, or a phone placeholder when it has none.
export default function AppIcon({ url, size }: { url: string | null; size: number }) {
  return url ? (
    <Avatar shape="square" size={size} src={url} style={{ borderRadius: size / 5 }} />
  ) : (
    <Avatar
      shape="square"
      size={size}
      icon={<MobileOutlined />}
      style={{ borderRadius: size / 5, background: '#e6edff', color: '#4c6ef5' }}
    />
  );
}
